export default {
  optionDescriptionRendererColor: Styles.color.grey.one,
  sectionDescriptionRendererColor: Styles.color.grey.one,
};
